export default __webpack_public_path__ + "static/media/MaskGroup.7732e1e6.svg";